import { createContext, useContext, useState, useEffect } from "react";
import { Outlet } from "react-router-dom";
import { CLUTCH_CONFIG } from "./ClutchConfig";
import "./clutch.css";

const ClutchCtx = createContext(null);
export const useClutch = () => useContext(ClutchCtx);

export const ClutchProvider = ({ children }) => {
  const [details, setDetails] = useState({ name: "", age: "", height: "", weight: "", gender: "", phone: "" });
  const [result, setResult] = useState(null); // { score, verdict, blurb, goals, attempts, peakBpm, vitals, stressPct }
  const [auth, setAuth] = useState(null); // { id_token, refresh_token } after mobile OTP sign-in

  // Called on successful OTP sign-in with the tokens returned by /auth/sign-in
  const login = ({ id_token, refresh_token }) => setAuth({ id_token, refresh_token });

  useEffect(() => {
    document.documentElement.style.setProperty("--cl-accent", CLUTCH_CONFIG.accent);
    document.documentElement.style.setProperty("--cl-accent2", CLUTCH_CONFIG.accent2);
  }, []);

  return (
    <ClutchCtx.Provider value={{ config: CLUTCH_CONFIG, details, setDetails, result, setResult, auth, login }}>
      {children}
    </ClutchCtx.Provider>
  );
};

/* Layout route — keeps flow state alive across navigations */
export const ClutchLayout = () => (
  <ClutchProvider>
    <Outlet />
  </ClutchProvider>
);
